/** Reads a scheduled instant as the calendar day it falls on, `yyyy-MM-dd`. */
export type CalendarDayFormat = (scheduledAt: string) => string

/**
 * Builds the day an instant falls on, in the zone the reader is in.
 *
 * The week view places content by the reader's own day, so the month has to as
 * well: without this a post at six in the evening Pacific sits on Thursday in
 * the week and Wednesday in the month for the same person in Berlin.
 *
 * The formatter is built once and used for every item of a month: building one
 * per item is the expensive part of `Intl`.
 *
 * @param timeZone An IANA zone name. Defaults to the one the browser is set to.
 */
export const createCalendarDayFormat = (
  timeZone?: string
): CalendarDayFormat => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    day: '2-digit',
    month: '2-digit',
    timeZone,
    year: 'numeric',
  })

  return (scheduledAt) => {
    const parts = formatter.formatToParts(new Date(scheduledAt))
    const value = (type: string) =>
      parts.find((part) => part.type === type)?.value

    return `${value('year')}-${value('month')}-${value('day')}`
  }
}
